module.exports = __webpack_public_path__ + "img/ImmerDieseFotos.df73234b.svg";